export default function buildQueryOpts(filtro) {
  const element = mapToServerFiltro(filtro);
  if (element) {
    let filters = '';
    for (const [key, value] of Object.entries(element)) {
      if (value) {
        if (Array.isArray(value)) {
          if (value.length > 0) {
            let array = '';
            for (let index = 0; index < value.length; index++) {
              if (index > 0) {
                array += ',';
              }
              array += value[index];
            }
            filters += `&${key}=${array}`;
          }
        } else {
          filters += `&${key}=${value}`;
        }
      }
    }
    return filters;
  }
  return '';
}

/**
 * Se mapea el arreglo de propiedades a campos simples
 * para el filtro en el servidor, de tal manera que se
 * puedan codificar como Query params sencillos
 *
 */
function mapToServerFiltro(filtro) {
  const { propiedades: _, ...serverFiltro } = filtro;
  if (filtro?.propiedades?.length > 0) {
    filtro.propiedades.forEach(item => {
      serverFiltro[item.path] = item.valor;
    });
  }
  return serverFiltro;
}
